"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ACTIVATION_CHECK_CODES () {
        return _tenantlifecycle.ACTIVATION_CHECK_CODES;
    },
    get ActivationChecksResponseSchema () {
        return _tenantlifecycle.ActivationChecksResponseSchema;
    },
    get ActivationChecksSchema () {
        return _tenantlifecycle.ActivationChecksSchema;
    },
    get BleedTestResultSchema () {
        return _tenantlifecycle.BleedTestResultSchema;
    },
    get ChangeEmrInstanceStatusRequestSchema () {
        return _emrinstances.ChangeEmrInstanceStatusRequestSchema;
    },
    get ChangeEmrInstanceStatusResponseSchema () {
        return _emrinstances.ChangeEmrInstanceStatusResponseSchema;
    },
    get ChangeIdis2goLinkRequestSchema () {
        return _idis2golinks.ChangeIdis2goLinkRequestSchema;
    },
    get ChangeIdis2goLinkResponseSchema () {
        return _idis2golinks.ChangeIdis2goLinkResponseSchema;
    },
    get ChangeTenantStatusRequestSchema () {
        return _tenantlifecycle.ChangeTenantStatusRequestSchema;
    },
    get ChangeTenantStatusResponseSchema () {
        return _tenantlifecycle.ChangeTenantStatusResponseSchema;
    },
    get ChangeTenantUserStatusRequestSchema () {
        return _tenantusers.ChangeTenantUserStatusRequestSchema;
    },
    get ClinicIntegrationEmrInstanceSchema () {
        return _integrationstatus.ClinicIntegrationEmrInstanceSchema;
    },
    get ClinicIntegrationStatusResponseSchema () {
        return _integrationstatus.ClinicIntegrationStatusResponseSchema;
    },
    get CreateIdis2goLinkRequestSchema () {
        return _idis2golinks.CreateIdis2goLinkRequestSchema;
    },
    get CreateIdis2goLinkResponseSchema () {
        return _idis2golinks.CreateIdis2goLinkResponseSchema;
    },
    get CreateTenantRequestSchema () {
        return _tenantlifecycle.CreateTenantRequestSchema;
    },
    get CreateTenantResponseSchema () {
        return _tenantlifecycle.CreateTenantResponseSchema;
    },
    get EMR_INSTANCE_ERROR_CODES () {
        return _emrinstances.EMR_INSTANCE_ERROR_CODES;
    },
    get EMR_INSTANCE_KEY_STATUSES () {
        return _emrinstances.EMR_INSTANCE_KEY_STATUSES;
    },
    get EMR_INSTANCE_MAX_LIVE_KEYS () {
        return _emrinstances.EMR_INSTANCE_MAX_LIVE_KEYS;
    },
    get EMR_INSTANCE_NAME_MAX_LENGTH () {
        return _emrinstances.EMR_INSTANCE_NAME_MAX_LENGTH;
    },
    get EMR_INSTANCE_STATUSES () {
        return _emrinstances.EMR_INSTANCE_STATUSES;
    },
    get EmrInstanceKeyListResponseSchema () {
        return _emrinstances.EmrInstanceKeyListResponseSchema;
    },
    get EmrInstanceKeySchema () {
        return _emrinstances.EmrInstanceKeySchema;
    },
    get EmrInstanceListResponseSchema () {
        return _emrinstances.EmrInstanceListResponseSchema;
    },
    get EmrInstanceSchema () {
        return _emrinstances.EmrInstanceSchema;
    },
    get IDIS2GO_BACKFILL_STATUSES () {
        return _idis2golinks.IDIS2GO_BACKFILL_STATUSES;
    },
    get IDIS2GO_LINK_ERROR_CODES () {
        return _idis2golinks.IDIS2GO_LINK_ERROR_CODES;
    },
    get INGEST_LAG_ALARM_SECONDS () {
        return _integrationstatus.INGEST_LAG_ALARM_SECONDS;
    },
    get Idis2goCustomerListResponseSchema () {
        return _idis2golinks.Idis2goCustomerListResponseSchema;
    },
    get Idis2goCustomerSchema () {
        return _idis2golinks.Idis2goCustomerSchema;
    },
    get Idis2goDiscoveryRunResponseSchema () {
        return _idis2golinks.Idis2goDiscoveryRunResponseSchema;
    },
    get Idis2goLinkBackfillSchema () {
        return _idis2golinks.Idis2goLinkBackfillSchema;
    },
    get Idis2goLinkListResponseSchema () {
        return _idis2golinks.Idis2goLinkListResponseSchema;
    },
    get Idis2goLinkSchema () {
        return _idis2golinks.Idis2goLinkSchema;
    },
    get Idis2goLinkStartRequestSchema () {
        return _idis2golinks.Idis2goLinkStartRequestSchema;
    },
    get Idis2goLinkStartSchema () {
        return _idis2golinks.Idis2goLinkStartSchema;
    },
    get Idis2goLinkedClinicSchema () {
        return _idis2golinks.Idis2goLinkedClinicSchema;
    },
    get IngestLagSchema () {
        return _integrationstatus.IngestLagSchema;
    },
    get IngestPollSchema () {
        return _integrationstatus.IngestPollSchema;
    },
    get IntegrationEmrInstanceSchema () {
        return _integrationstatus.IntegrationEmrInstanceSchema;
    },
    get IntegrationLinkBackfillSchema () {
        return _integrationstatus.IntegrationLinkBackfillSchema;
    },
    get IntegrationLinkSchema () {
        return _integrationstatus.IntegrationLinkSchema;
    },
    get IntegrationOverviewClinicSchema () {
        return _integrationstatus.IntegrationOverviewClinicSchema;
    },
    get IntegrationOverviewResponseSchema () {
        return _integrationstatus.IntegrationOverviewResponseSchema;
    },
    get InviteTenantUserRequestSchema () {
        return _tenantusers.InviteTenantUserRequestSchema;
    },
    get InviteTenantUserResponseSchema () {
        return _tenantusers.InviteTenantUserResponseSchema;
    },
    get IssueEmrInstanceKeyRequestSchema () {
        return _emrinstances.IssueEmrInstanceKeyRequestSchema;
    },
    get IssueEmrInstanceKeyResponseSchema () {
        return _emrinstances.IssueEmrInstanceKeyResponseSchema;
    },
    get MISSING_FILES_WINDOW_DAYS () {
        return _integrationstatus.MISSING_FILES_WINDOW_DAYS;
    },
    get PLATFORM_TENANT_SLUG () {
        return _tenantlifecycle.PLATFORM_TENANT_SLUG;
    },
    get RESULT_FILE_MISSING_REASONS () {
        return _integrationstatus.RESULT_FILE_MISSING_REASONS;
    },
    get RESULT_FILE_STATUSES () {
        return _integrationstatus.RESULT_FILE_STATUSES;
    },
    get RegisterEmrInstanceRequestSchema () {
        return _emrinstances.RegisterEmrInstanceRequestSchema;
    },
    get RegisterEmrInstanceResponseSchema () {
        return _emrinstances.RegisterEmrInstanceResponseSchema;
    },
    get ReplaceTenantUserRolesRequestSchema () {
        return _tenantusers.ReplaceTenantUserRolesRequestSchema;
    },
    get ResultCountsSchema () {
        return _integrationstatus.ResultCountsSchema;
    },
    get TENANT_KINDS () {
        return _tenantlifecycle.TENANT_KINDS;
    },
    get TENANT_LIFECYCLE_ERROR_CODES () {
        return _tenantlifecycle.TENANT_LIFECYCLE_ERROR_CODES;
    },
    get TENANT_NAME_MAX_LENGTH () {
        return _tenantlifecycle.TENANT_NAME_MAX_LENGTH;
    },
    get TENANT_SLUG_MAX_LENGTH () {
        return _tenantlifecycle.TENANT_SLUG_MAX_LENGTH;
    },
    get TENANT_SLUG_MIN_LENGTH () {
        return _tenantlifecycle.TENANT_SLUG_MIN_LENGTH;
    },
    get TENANT_SLUG_PATTERN () {
        return _tenantlifecycle.TENANT_SLUG_PATTERN;
    },
    get TENANT_STATUSES () {
        return _tenantlifecycle.TENANT_STATUSES;
    },
    get TENANT_USER_DISPLAY_NAME_MAX_LENGTH () {
        return _tenantusers.TENANT_USER_DISPLAY_NAME_MAX_LENGTH;
    },
    get TENANT_USER_EMAIL_MAX_LENGTH () {
        return _tenantusers.TENANT_USER_EMAIL_MAX_LENGTH;
    },
    get TENANT_USER_ERROR_CODES () {
        return _tenantusers.TENANT_USER_ERROR_CODES;
    },
    get TENANT_USER_MAX_ROLES () {
        return _tenantusers.TENANT_USER_MAX_ROLES;
    },
    get TENANT_USER_STATUSES () {
        return _tenantusers.TENANT_USER_STATUSES;
    },
    get TenantCountsSchema () {
        return _tenantlifecycle.TenantCountsSchema;
    },
    get TenantListResponseSchema () {
        return _tenantlifecycle.TenantListResponseSchema;
    },
    get TenantNameSchema () {
        return _tenantlifecycle.TenantNameSchema;
    },
    get TenantRoleListResponseSchema () {
        return _tenantusers.TenantRoleListResponseSchema;
    },
    get TenantRoleSchema () {
        return _tenantusers.TenantRoleSchema;
    },
    get TenantSlugSchema () {
        return _tenantlifecycle.TenantSlugSchema;
    },
    get TenantSummarySchema () {
        return _tenantlifecycle.TenantSummarySchema;
    },
    get TenantUserListResponseSchema () {
        return _tenantusers.TenantUserListResponseSchema;
    },
    get TenantUserResponseSchema () {
        return _tenantusers.TenantUserResponseSchema;
    },
    get TenantUserRoleSchema () {
        return _tenantusers.TenantUserRoleSchema;
    },
    get TenantUserSchema () {
        return _tenantusers.TenantUserSchema;
    }
});
const _tenantlifecycle = require("./tenant-lifecycle");
const _tenantusers = require("./tenant-users");
const _emrinstances = require("./emr-instances");
const _idis2golinks = require("./idis2go-links");
const _integrationstatus = require("./integration-status");
